module.exports = __webpack_public_path__ + "img/nekomy.d1db9adc.jpg";